import React, { useState, useEffect } from 'react';
import Spinner from './common/Spinner';

// Search-specific loading messages
const SEARCH_MESSAGES = [
  "מחפש את המחיר הטוב ביותר...",
  "שווה לחכות...",
  "משווה בין כל האתרים...",
  "בוטי מחפש לכם, לא ללחוץ עליו...",
  "עובר על כככככל האמזונים...",
  "רק עוד קצת...",
];

export default function SearchSpinner({ 
  message = '', 
  messages = SEARCH_MESSAGES, 
  messageInterval = 1500,
  ...props 
}) {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  // Handle message rotation
  useEffect(() => {
    if (messages.length > 1) {
      const intervalId = setInterval(() => {
        setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
      }, messageInterval);

      return () => clearInterval(intervalId);
    }
  }, [messages.length, messageInterval]);

  const currentMessage = message || messages[currentMessageIndex];

  return <Spinner variant="search" message={currentMessage} className="pt-4" {...props} />;
}

